import { z } from 'zod';
export const PricingInput = z
    .object({
    supplierCostUsd: z.number().nonnegative(),
    shippingCostUsd: z.number().nonnegative().default(0),
    fxRate: z.number().positive().default(1.36),
    ebayFeePct: z.number().min(0).max(0.3).default(0.13),
    paypalFlatCad: z.number().nonnegative().default(0.3),
    paypalPctCad: z.number().min(0).max(0.1).default(0.029),
    desiredProfitCad: z.number().nonnegative().default(8),
})
    .strict();
export function calculatePricing(input) {
    const costCad = (input.supplierCostUsd + input.shippingCostUsd) * input.fxRate;
    const variableFeePct = input.ebayFeePct + input.paypalPctCad;
    const numerator = costCad + input.paypalFlatCad + input.desiredProfitCad;
    const storePriceCad = numerator / (1 - variableFeePct);
    const feesCad = storePriceCad * variableFeePct + input.paypalFlatCad;
    const profitCad = storePriceCad - costCad - feesCad;
    const marginPct = profitCad / storePriceCad;
    const verdict = marginPct >= 0.2 ? 'good' : marginPct >= 0.1 ? 'warn' : 'bad';
    return { costCad, feesCad, storePriceCad, profitCad, marginPct, verdict };
}
//# sourceMappingURL=pricing.js.map